import { render, staticRenderFns } from "./IconPauseOutline.vue?vue&type=template&id=4da87a54"
import script from "./IconPauseOutline.vue?vue&type=script&lang=js"
export * from "./IconPauseOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports